import script from "./BookCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BookCard.vue?vue&type=script&setup=true&lang=js"

import "./BookCard.vue?vue&type=style&index=0&id=56d48e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d48e56"]])

export default __exports__